import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import { matchPath } from "react-router-dom";
import { LOCALES } from "./data/constants";

const DEFAULT_LANGUAGE = "en"

export function detectLocaleFromUrl(): string | null {
  const path = window.location.pathname;
  const localeMatch = matchPath({ path: "/:locale/*" }, path);

  const locale = localeMatch?.params?.locale;

  if (locale && LOCALES.includes(locale)) {
    return locale;
  }

  return null;
}

const currentLanguage = detectLocaleFromUrl() || DEFAULT_LANGUAGE;

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: currentLanguage,
    fallbackLng: false,
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on("failedLoading", (lng, ns, msg) => {
  console.error(
    `Failed to load language: ${lng}, namespace: ${ns}, error: ${msg}`
  );
  console.error(`Attempted to load: /locales/${lng}/translation.json`);
});

export default i18n;
